module.exports = __webpack_public_path__ + "img/huge.5eec9d5c.png";